<template>
  <div class="admin-device-popup">
     <base-popup @close="$emit('close-popup')">
      <template #actions>
        <base-button class="admin-device-popup__btn-save" outline @click="saveDevice">
          <pen-icon class="admin-device-popup__icon-btn-save" />
          Save
        </base-button>
      </template>
      <div class="admin-device-popup__container-title">
        <h3 class="admin-device-popup__title">
          DEVICE ID: {{deviceId}}
        </h3>
        <base-pill class="admin-device-popup__title-status" :active="activeDevice">{{statusDevice}}</base-pill>
      </div>
      <base-pop-up-card>
          <template #card-header>
            DEVICE INFORMATION
          </template>
          <div class="admin-device-popup__container-card-column">
            <div class="admin-device-popup__card-main-column admin-device-popup__card-column_w-30">
              <div class="admin-device-popup__card-column-section">
                <label class="admin-device-popup__label">
                  Manufacturer ID
                </label>
                <base-input class="admin-device-popup__input" v-model="manufacturerIdDevice" />
              </div>
              <div class="admin-device-popup__card-column-section">
                <label class="admin-device-popup__label">
                  Side
                </label>
                <base-select class="admin-device-popup__input" :items="$options.itemSideDevice" v-model="sideDevice" />
              </div>
              <div class="admin-device-popup__card-column-section">
                <label class="admin-device-popup__label">
                  Driver
                </label>
                <base-input class="admin-device-popup__input" v-model="driverDevice" />
              </div>
              <div class="admin-device-popup__card-column-section">
                <label class="admin-device-popup__label">
                  Status
                </label>
                <base-select class="admin-device-popup__input" :items="itemStateDevice" v-model="stateDevice" />
              </div>
              <div class="admin-device-popup__card-column-section" v-if="lastPhotos.length">
                <label class="admin-device-popup__label">
                  Last photos:
                </label>
                <div class="admin-device-popup__container-photos-links">
                  <div class="admin-device-popup__photo-link" v-for="photo in lastPhotos" :key="photo.order">
                    <a class="admin-device-popup__link" :href="photo.url" target="_blank">{{photo.label}}</a>
                  </div>
                </div>
              </div>
              <div class="admin-device-popup__card-column-section">
                <base-checkbox v-model="activeDeviceInput">ACTIVE</base-checkbox>
              </div>
              <div class="admin-device-popup__card-column-section">
                <control-device :idDevice="deviceId" />
              </div>
            </div>
            <div class="admin-device-popup__card-main-column admin-device-popup__card-column_w-70">
              <div class="admin-device-popup__container-card-column">
                <div class="admin-device-popup__card-column admin-device-popup__card-column_w-50">
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Activated
                    </label>
                    <base-input class="admin-device-popup__input" disabled v-model="activatedDevice" />
                  </div>
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Last Online
                    </label>
                    <base-input class="admin-device-popup__input" disabled v-model="lastOnlineDevice" />
                  </div>
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Last Calibrated
                    </label>
                    <base-input class="admin-device-popup__input" disabled v-model="lastCalibratedDevice" />
                  </div>
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Total working time
                    </label>
                    <base-input class="admin-device-popup__input" disabled v-model="totalWorkingTimeDevice" />
                  </div>
                </div>
                <div class="admin-device-popup__card-column admin-device-popup__card-column_w-50">
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Notes
                    </label>
                    <base-textarea class="admin-device-popup__textarea"  v-model="notesDevice"/>
                  </div>
                  <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      Alerts
                    </label>
                    <div class="admin-device-popup__info" v-html="alertsDevice"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="admin-device-popup__card-column-section">
                    <label class="admin-device-popup__label">
                      KPIs:
                    </label>
                    <div class="admin-device-popup__info">
                      <device-kpi :kpis="kpis"></device-kpi>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </base-pop-up-card>
        <base-pop-up-card>
          <template #card-header>
            DRIVING DATA
          </template>
          <driving-date-device :deviceId="deviceId"/>
        </base-pop-up-card>
    </base-popup>
  </div>
</template>

<script>
import BaseButton from '@/components/common/BaseButton.vue'
import BaseCheckbox from '@/components/common/BaseCheckbox.vue'
import BaseInput from '@/components/common/BaseInput.vue'
import BasePill from '@/components/common/BasePill.vue'
import BasePopup from '@/components/common/BasePopup.vue'
import BasePopUpCard from '@/components/common/BasePopUpCard.vue'
import BaseSelect from '@/components/common/BaseSelect.vue'
import BaseTextarea from '@/components/common/BaseTextarea.vue'
import ControlDevice from '@/components/admin/AdminDevices/ControlDevice.vue'
import DeviceKpi from '@/components/admin/AdminDevices/DeviceKpi.vue'
import toast from '@utils/toast.js'
import DrivingDateDevice from '@/components/admin/AdminDevices/DrivingDateDevice.vue'
import PenIcon from '@/components/svg/PenIcon.vue'

const ITEMS_SIDE_DEVICE = [
  { label: 'driver', value: 'driver'},
  { label: 'passenger', value: 'passenger'}

]

export default {
  name: "AdminDevicePopUp",
  components: { 
    BasePopUpCard,
    BaseInput,
    BaseSelect,
    BaseButton,
    BasePopup,
    BasePill,
    BaseCheckbox,
    BaseTextarea,
    DeviceKpi,
    ControlDevice,
    DrivingDateDevice,
    PenIcon
  },
  props: {
    deviceId: {
      type: String,
      required: true,
    }
  },
  
  itemSideDevice: ITEMS_SIDE_DEVICE,

  data() {
    return {
      statusDevice: '',
      activeDevice: false,
      manufacturerIdDevice: '',
      sideDevice: '',
      driverDevice: '',
      initDriverDevice: '',
      stateDevice: 0,
      lastPhotos: [],
      activeDeviceInput: false,
      activatedDevice: '',
      lastOnlineDevice: '',
      lastCalibratedDevice: '',
      totalWorkingTimeDevice: '',
      notesDevice: '',
      alertsDevice: '',
      kpis: [],
    }
  },

  computed: {
    itemStateDevice() {
      const device_states = this.$store.getters.getSchema.device_states
      return device_states.map(state => ({value: state.id, label: state.name}))
    }
  },

  mounted() {
    this.getDevice()
  },

  methods: {
    getDevice() {
      const body = {
          data: {
              device_id: this.deviceId
          }
      }
      this.request('/admin/get/device', 'POST', body).then( response => {
          if ( response.code === 0 ) {
              this.setDevice(response.data)
          } else {
            toast.errorMessage(response.message)
          }
      }).catch(error => {
        console.error(error);
      })
    },

    setDevice(data) {
      this.statusDevice = data.status
      this.activeDevice = data.active
      this.activeDeviceInput = data.active
      this.manufacturerIdDevice = data.manufacturer_id
      this.sideDevice = data.side
      this.driverDevice = data.driver
      this.initDriverDevice = data.driver
      this.stateDevice = data.state
      this.lastPhotos = data.photos
      this.activatedDevice = data.activated
      this.lastOnlineDevice = data.last_online
      this.lastCalibratedDevice = data.last_calibrated
      this.totalWorkingTimeDevice = data.working_time
      this.notesDevice = data.notes
      this.alertsDevice = data.alerts
      this.kpis = data.KPIs
    },

    async saveDevice() {
      const url = '/admin/set/device'
      const body = {
        data: {
          device_id: this.deviceId,
          side: this.sideDevice,
          manufacturer_id: this.manufacturerIdDevice,
          notes: this.notesDevice,
          state: this.stateDevice,
          active: this.activeDeviceInput,
        }        
      }
      if (this.driverDevice !== this.initDriverDevice) {
        body.data.driver_id = this.driverDevice
      }
      try {
        const response = await this.request(url, 'POST', body)
        if (response.code === 0 ) {
          this.$emit('updated-driver')
        } else toast.errorMessage(response.message)
      } catch (e) {
        console.error(e);
      }
    }
  }

}
</script>

<style>
.admin-device-popup__btn-save {
  margin-right: 10px;
}

.admin-device-popup__icon-btn-save {
  margin-right: 10px;
}

.admin-device-popup__container-title {
  display: flex;
  align-items: center;
  text-align: left;
}

@media screen and (max-width: 975px){
  .admin-device-popup__container-title {
    margin-top: 50px;
  }
}

.admin-device-popup__title {
  font-size: 16px;
}

@media screen and (max-width: 660px){
  .admin-device-popup__title {
    font-size: 14px;
  }
}

@media screen and (max-width: 460px){
  .admin-device-popup__title {
    font-size: 12px;
  }
}

@media screen and (max-width: 400px){
  .admin-device-popup__title {
    font-size: 10px;
  }
}


.admin-device-popup__title-status {
  margin-left: 20px;
}

.admin-device-popup__container-card-column {
  display: flex;
  flex-wrap: wrap;
}

.admin-device-popup__card-main-column {
  margin-right: 45px;
}

.admin-device-popup__card-main-column:last-of-type {
  margin-right: 0;
}

.admin-device-popup__card-column_w-30 {
  width: calc(30% - 45px);
  min-width: 270px;
}

.admin-device-popup__card-column_w-50 {
  width: calc(50% - 8px);
}

.admin-device-popup__card-column_w-50:first-of-type {
  margin-right: 15px;
}

.admin-device-popup__card-column_w-70 {
  width: 70%;
}

 @media screen and (max-width: 1355px){
  .admin-device-popup__card-column_w-70 {
    width: 100%;
    min-width: auto;
  }
  .admin-device-popup__card-column_w-30 {
    width: 100%;
    min-width: auto;
  }
}

 @media screen and (max-width: 1355px){
    .admin-device-popup__card-column_w-50 {
      width: 100%;
      min-width: auto;
    }
  }

.admin-device-popup__card-column-section {
  text-align: left;
  margin-bottom: 15px;
}

.admin-device-popup__label {
  font-size: 14px;
  margin-bottom: 5px;
  padding: 0;
  margin-top: 0;
}

.admin-device-popup__input {
  width: 100%;
}

.admin-device-popup__card-column-section .admin-device-popup__textarea {
  width: 100%;
  height: 150px;
}

.admin-device-popup__info {
  background: #FFFFFF;
  border: 1px solid #CCD4E0;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
  font-size: 14px;
}

.admin-device-popup__container-photos-links {
  display: flex;
  flex-wrap: wrap;
  margin-top: 7px;
}

.admin-device-popup__photo-link {
  width: 50%;
}

.admin-device-popup__link {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #2F82FF;
  text-decoration: none;
}
</style>